import TablaConciliacion from "../../../TablaConciliacion";

function TablaCoviandina() {
  return <TablaConciliacion nombreUseCase="COVIANDINA" titulo="COVIANDINA" />;
}

export default TablaCoviandina;
